import React, { useEffect } from 'react';
import { useProcessTokenMutation } from '../../features/authentication/authApiSlice';

const GoogleAccess = () => {
  const [getProcessToken] = useProcessTokenMutation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      checkAuthCode();
    }
  }, []);

  const checkAuthCode = async () => {
    const base64Encoded = btoa(unescape(encodeURIComponent(window.location.href)));
    const options = {
      url: base64Encoded
    };
    await getProcessToken(options).unwrap();
    window.opener.postMessage('googleAccessAllowed', '*');
    window.close(); // Optionally close the Google access tab
  };

  return (
    <div>
      <p>Google authentication in progress...</p>
    </div>
  );
};

export default GoogleAccess;
